export default {
  DownloadBase64File(file, filename, type = 'file') {
    //读取base文件
    // base64toBlob
    file = base64toBlob(file, type)
    const blob = new Blob([file], { type })
    let ua = window.navigator.userAgent
    if (ua.indexOf('MSIE') != -1 || ua.indexOf('rv:11.0') != -1) {
      navigator.msSaveBlob(blob, filename)
    } else {
      let link = document.createElement('a')
      link.download = filename
      link.style.display = 'none'
      document.body.appendChild(link)
      link.href = window.URL.createObjectURL(blob)
      link.click()
      document.body.removeChild(link)
    }
  },
  //文本下载
  funDownload(content, filename) {
    var element = document.createElement('a')
    var eleLink = document.createElement('a')
    eleLink.download = filename
    eleLink.style.display = 'none'
    var blob = new Blob([content])
    let ua = window.navigator.userAgent
    if (ua.indexOf('MSIE') != -1 || ua.indexOf('rv:11.0') != -1) {
      navigator.msSaveBlob(blob)
      return
    }
    eleLink.href = URL.createObjectURL(blob)
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  },
  //复制
  copy(str) {
    var oInput = document.createElement('textarea')
    oInput.value = str
    document.body.appendChild(oInput)
    oInput.select() // 选择对象
    document.execCommand('Copy') // 执行浏览器复制命令
    oInput.className = 'oInput'
    oInput.style.display = 'none'
    alert('Copy successfully')
  },
}
function base64toBlob(base64, type) {
  // 将base64转为Unicode规则编码
  const bstr = atob(base64, type)
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n) // 转换编码后才可以使用charCodeAt 找到Unicode编码
  }
  return new Blob([u8arr], {
    type,
  })
}
